// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';

import styles from './styles';

class Store extends React.Component {
  state = {};

  render() {
    const { classes, store } = this.props;
    const distance = 'Distance - ';
    return (
      <div className={classes.mainContainer}>
        <span className={classes.storeName}>{store.name}</span>
        <span className={classes.mainInfoContainer}>
          {store.info.map(el => <span key={uuidv4()}>{el}</span>)}
        </span>
        <span>
          <span className={classes.defaultBold}>{distance}</span>
          {store.distance}
        </span>
        <span className={classes.workTimeContainer}>
          {store.workTime.map(el => (
            <span key={uuidv4()} className={classes.workTimeSubContainer}>
              <span className={classes.defaultBold}>{el.title}</span>
              <span>{el.time}</span>
            </span>
          ))}
        </span>
      </div>
    );
  }
}

Store.propTypes = {
  classes: PropTypes.object,
  store: PropTypes.object,
};

Store.defaultProps = {
  classes: {},
  store: {},
};

export default withStyles(styles)(Store);
